import { isInteger } from 'common/helpers/primitives/isType'


const normalizeDateFormat = (date: string): string => {
  if (/^\d{8}$/.test(date)) {
    if (isInteger(date)) {
      date = String(date)
    }

    // converts 01272017 to 01/27/2017
    return `${date.slice(0, 2)}/${date.slice(2, 4)}/${date.slice(-4)}`
  }

  return date
}

export default normalizeDateFormat
